import EventEmitter from 'amkit3-modules/utils/stateful-events'
import fallbackImgSrc from 'amkit3-modules/utils/fallback-img-src'
import { getLogger } from 'amkit3-modules/utils/log4js'

import themeFactory from './themes/factory'
import HuyaUIEvent from './huya-ui-event'

const logger = getLogger('v/ui/huya/ended-recommend')

class EndedRecommendPanel extends EventEmitter {
  constructor($, $container, options) {
    super()

    this.$ = $
    this.$container = $container
    this._options = options
    this._style = themeFactory.getStyle()
    this._selector = themeFactory.getSelector()
    this._resizeCb = this.resize.bind(this)

    this.$panel = this.$container.find(this._selector.endedRecommend)
    this.$panel.on(
      'click',
      this._selector.endedRecommendLiveInfoReplayBtn,
      () => this.emit(HuyaUIEvent.ENDED_RECOMMEND_REPLAY_BTN_CLICK),
    )
    this.$panel.on(
      'click',
      this._selector.endedRecommendLiveInfoCommentBtn,
      () => this.emit(HuyaUIEvent.ENDED_RECOMMEND_COMMENT_BTN_CLICK),
    )
    this.$panel.on(
      'click',
      this._selector.endedRecommendLiveInfoMainSubscribeBtn,
      () => this.emit(HuyaUIEvent.ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK),
    )
  }
  show(data) {
    logger.info('recommend show', data)

    let tpl = themeFactory.getEndedRecommendTpl()
    this.$panel.html(
      tpl({
        style: this._style,
        data,
        huya_video_base: process.env.TEST
          ? 'test-www.huya.com/video'
          : 'www.huya.com/video',
      }),
    )
    fallbackImgSrc(
      this.$panel.find(this._selector.endedRecommendLiveInfoAvatar).find('img'),
      '//v-cms-img.huya.com/huya/1212pic_v1.png',
    )
    fallbackImgSrc(
      this.$panel
        .find(this._selector.endedRecommendVideoListItemCover)
        .find('img'),
      '//vhuya-static.huya.com/amkit/p/duya/common/img/default_live.jpg',
    )

    this.$(window).on('resize', this._resizeCb)
    this.resize()

    // TODO
    global.vhuyaplayer_setUnsubscribe = () => this.setUnsubscribe()
    global.vhuyaplayer_setSubscribed = () => this.setSubscribed()
  }
  hide() {
    logger.info('recommend hide')
    this.$(window).off('resize', this._resizeCb)
  }
  resize() {
    let h = this.$container.height()

    if (h > 448) {
      this.showItems(6)
    } else {
      this.showItems(3)
    }
  }
  showItems(count) {
    this.$panel
      .find(this._selector.endedRecommendVideoListItem)
      .each((index, item) => {
        if (index < count) {
          this.$(item).show()
        } else {
          this.$(item).hide()
        }
      })
  }
  setUnsubscribe() {
    this.$panel
      .find(this._selector.endedRecommendLiveInfoMainSubscribeBtn)
      .addClass(this._style.unsubscribe)
      .removeClass(this._style.subscribed)
      .find('span')
      .text('订阅')
  }
  setSubscribed() {
    this.$panel
      .find(this._selector.endedRecommendLiveInfoMainSubscribeBtn)
      .addClass(this._style.subscribed)
      .removeClass(this._style.unsubscribe)
      .find('span')
      .text('已订阅')
  }
}

export default EndedRecommendPanel
